const logoutUser = async (instance, account) => {
    if (!instance) {
        return;
    }

    await instance.logoutRedirect(account ? { account } : undefined);
};

export { logoutUser };
